import { useEffect } from "react";

interface PageMeta {
  title: string;
  description: string;
  keywords?: string;
}

const setMeta = (name: string, content: string, attribute: "name" | "property" = "name") => {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

export const usePageMeta = ({ title, description, keywords }: PageMeta) => {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    if (keywords) setMeta("keywords", keywords);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");
    setMeta("twitter:card", "summary_large_image");
  }, [title, description, keywords]);
};

export const homeMeta = {
  title: "蜜桃33—海量影视剧资源在线观看与介绍",
  description:
    "蜜桃33致力于提供全面的影视剧资源，包括电影、电视剧和综艺节目，支持在线观看和剧情介绍，满足用户多样的观影需求。",
  keywords: "蜜桃33,影视资源,电影在线观看,电视剧介绍,影视剧推荐",
};